import { Row, Switch } from "antd";
import { useCallback } from "react";

type FiltersProps = {
  isLoading: boolean;
  setUnread: React.Dispatch<React.SetStateAction<boolean>>;
};

export const Filters = ({ isLoading, setUnread }: FiltersProps) => {
  const onChange = useCallback(() => {
    setUnread((prev: boolean) => !prev);
  }, [setUnread]);

  return (
    <Row className="align-center filters">
      <Row className="align-center">
        <Switch onChange={onChange} disabled={isLoading} />
        <span className="ml-2">Unread Only</span>
      </Row>
    </Row>
  );
};
